import React, { useState, useEffect } from 'react'
import { Spinner } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { activateUser } from '../Network/Authentication'
import "./Activate.css"

function Activate() {
    const { token } = useParams()
    const [isActivated, setActivated] = useState(false)
    const [isError, setError] = useState(false)
    const [errormessage, setErrormessage] = useState("")

    useEffect(()=>{
        const activateAccount = () =>{
            activateUser(token, 
                ()=>{
                    setActivated(true)
                },
                (error)=>{
                    setError(true)
                    if(error.response !== null){
                        setErrormessage(error.response.data.message)
                    }else{
                        setErrormessage(error.message)
                    }
                })
        }

        activateAccount()
    },[token])

    return (
        <div id="activate">
            <div id="container">
                { !isActivated ?
                <>
                    { !isError ?
                    <ActivateInProgress/>
                    :
                    <ActivateError message={errormessage}/>
                    }
                </>
                :
                <ActivateFinish/>
                }
            </div>
        </div>
    )
}

function ActivateInProgress(){
    return(
        <div>
            <div className="activity">
                <Spinner
                variant="primary"
                animation="border"
                style={{width: 40, height: 40}}
                />
            </div>
            <div>Please wait activating your account</div>
            <div>โปรดรอสักครู่ ระบบกำลังเปิดใช้งานบัญชี</div>
            <div className="sub-title" style={{marginTop: 10}}>Do not close this page</div>
            <div className="sub-title">กรุณาอย่าปิดหน้านี้</div>
                
        </div>
    )
}

function ActivateFinish(){
    return(
        <div>
            <div>
                <FontAwesomeIcon icon={faCheckCircle} className="finish-icon"/>
            </div>
            <div className="title">Activated Account</div>
            <div className="title">เปิดใช้งานบัญชีนี้แล้ว</div>
            <div className="nd-title" style={{marginTop:15}}>You can login with this account</div>
            <div className="nd-title">คุณสามารถเข้าสู่ระบบด้วยบัญชีนี้</div>
        </div>
    )
}

function ActivateError(props){
    return(
        <div>
            <div>
                <FontAwesomeIcon icon={faTimesCircle} className="fail-icon"/>
            </div>
            <div className="title">Failed to activate</div>
            <div className="title">การเปิดบัญชีล้มเหลว</div>
            <div className="nd-title" style={{marginTop:15}}>Please resend activate E-mail from <u>Lifelink</u> app to try again.</div>
            <div className="nd-title">โปรดส่งอีเมลการเปิดใช้งานใหม่จากแอปพลิเคชั่น <u>Lifelink</u> เพื่อลองอีกครั้ง</div>
            <div className="message">
                {props.message}
            </div>
        </div>
    )
}

export default Activate
